<template lang="es">
    <v-card elevation="0">
        <v-card-title>
            {{titulo}}
        </v-card-title>

        <!-- Filtro para tipos de tratamiento en las recetas -->
        <v-select  prepend-icon="mdi-magnify" class="ml-4 mr-4" v-if="tipo == 'receta'"  :items="tratamientos" item-text="name" :hint="tipo_tratamiento == '-'?'Seleccionar...':null" item-value="name" label="Tipo de Tratamiento"
          v-model="tipo_tratamiento">
          </v-select>
        <v-card-text>
            <v-data-table :search="tipo_tratamiento != '-'?tipo_tratamiento:null"
                :headers="datos.headers"
                :items="datos.items"
                :items-per-page="datos.items.length"
                class="elevation-1"
                hide-default-footer
            >
            <template  v-slot:[`item.action`]="{ item }" :style="'justify-content: center;'">
                <v-btn  v-if="tipo == 'receta' && Object.keys(trabajoCargado).length == 0" :disabled="!datosAntiguosCargados" color="green"  fab text  @click="cargar(item)" >
                <!-- <v-btn  v-if="tipo == 'receta' && Object.keys(trabajoCargado).length == 0"  color="green"  fab text  @click="cargar(item)" > -->
                <v-icon dark>mdi-upload</v-icon>
                </v-btn>
                <v-btn v-if=" Object.keys(trabajoCargado).length == 0 || item.id_receta != trabajoCargado.id_receta" color="blue darken-1"  fab text @click="editar(item)" >
                <v-icon dark>mdi-pencil</v-icon>
                </v-btn>
                <v-btn v-if=" Object.keys(trabajoCargado).length == 0 || item.id_receta != trabajoCargado.id_receta" color="red darken-1"  fab text @click="dialogo_eliminar = true; selectedItem = item">
                <v-icon dark>mdi-delete</v-icon>
                </v-btn>
            </template>
            <template v-slot:no-results>
                <span>No hay datos para esta búsqueda</span>
            </template>
            </v-data-table>
        </v-card-text>
        <v-card-actions>
            <!-- <v-btn>Cancelar</v-btn> -->
            <v-spacer></v-spacer>
            <v-btn color="blue" fab dark @click="nuevo()"><v-icon>mdi-plus</v-icon></v-btn>
        </v-card-actions>
        
        <!-- CONFIRMACION ELIMINAR RECETA -->
        <dialogo-confirmacion 
        :activar="dialogo_eliminar" 
        :tituloDialogo="tipo=='receta'?'ELIMINAR RECETA':'ELIMINAR TIPO'" 
        toolbarColor="red" 
        tipo=""
        buttonColor="red"
        :textoDialogo="`Seguro que quieres eliminar ${tipo=='receta'?'la receta':'el tipo'} '${selectedItem.name}'?`"    
        nombreMetodo="eliminar"
        @eliminar="eliminar(selectedItem)" 
        @cancelar="dialogo_eliminar = false; selectedItem = {}">
    </dialogo-confirmacion>
    </v-card>

</template>
<script>
import DialogoConfirmacion from "@/components/modulos/DialogoConfirmacion.vue";
import { mapState,mapActions } from 'vuex';
export default {
    props:{
        datos: Object,
        titulo:String,
        tipo:String,
    },
    data() {
        return {
            deltaTime:1,
            tipo_tratamiento:null,
            dialogo_eliminar:false,
            selectedItem:{}
        }
    },
    components:{
        DialogoConfirmacion
    },
    computed:{
        ...mapState(['trabajoCargado','datosAntiguosCargados', 'tipos_de_tratamiento']),
        tratamientos() {
            let tratamientos = JSON.parse(JSON.stringify(this.tipos_de_tratamiento));
            tratamientos.push({ id: null, name: "-" });
            return tratamientos;
        },
    },
    methods: {
        ...mapActions(['cargarReceta']),
        nuevo(){
            this.$emit('nuevo')
        },
        editar(item){
             console.log("edit",item);
             this.$emit('editar', item)
           
        },
        eliminar(item){
             console.log("eliminar",item);
             this.$emit('eliminar', item)
             this.dialogo_eliminar = false
             this.selectedItem = {}
        },
        cargar(item){
            let last_setpoint=null
            let tramos_a_cargar=[]
            let first_setpoint = null
            
            item.detalles.forEach((detalle, index) => {
                if(index==0){
                    first_setpoint=detalle.setpoint
                }
                //Poner tantos puntos como deltaTimes haya en este segmento
                const diferencia_tiempos_minutos = this.$diferencia_tiempos_minutos( detalle.hora_fin,detalle.hora_inicio)*60
                //Calcular pendiete como
                //(y1-y0)/diferencia_tiempos = (setpoint-last_setpoint)/diferencia_tiempos_minutos
                const pendiete_actual = (last_setpoint)? (detalle.setpoint-last_setpoint)/diferencia_tiempos_minutos:0;

                tramos_a_cargar.push({
                    tiempo:diferencia_tiempos_minutos,
                    pendiente:pendiete_actual,
                    tolerancia_max:detalle.tolerancia_max,
                    tolerancia_min:detalle.tolerancia_min
                })

                last_setpoint=detalle.setpoint;


            })
            const envio={
                first_setpoint,
                raw:item,
                payload:tramos_a_cargar,
                'deltaTime':this.deltaTime
            }

            this.cargarReceta(envio)
        }
    },

}
</script>
<style lang="">
    
</style>